import React, { } from "react";
import { } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Card,
  Button,
} from '@lockerpm/design';
import {
} from "@ant-design/icons";

const DangerZone = (props) => {
  const { } = props
  const { t } = useTranslation();

  return (
    <Card
      bodyStyle={{
        padding: 16
      }}
    >
      <div className="flex justify-between">
        <p className="font-semibold text-danger">
          {t('account_details.danger_zone.delete_data')}
        </p>
        <Button type='primary' danger disabled>
          {t('button.delete_data')}
        </Button>
      </div>
      <p>
        {t('account_details.danger_zone.delete_data_desc')}
      </p>
    </Card>
  );
}

export default DangerZone;